import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from '@src/pc/components/Footer';
import TableList from '@src/pc/components/TableList';
import Banner from '@src/pc/components/Banner';

const Layout = ({ content }) => {
    const { footer, assist } = content;
    const assistList = assist?.results || [];

    return (
        <div className={styles.layout}>
            <Banner content="https://x0.ifengimg.com/ucms/2022_46/5156ECC30E7D4C36C529817A93BD77678B25F9A8_size15_w538_h222.png" />
            <div className={styles.column}>
                <TableList content={assistList} />
            </div>
            <div className={styles.space_90} />
            <div className={styles.column}>
                <Footer content={footer} />
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
